module.exports = __webpack_public_path__ + "img/icon-tianjia.26882041.svg";